// react
import styled, { css } from 'styled-components';

// theme
import theme from '@/theme';
import { Color } from '@/theme/color';

type Gradient = 'none' | 'top' | 'bottom' | 'left' | 'right';

interface BackgroundProps {
  className?: string;
  children?: React.ReactNode;
  color?: Color;
  src?: string;
  gradient?: Gradient;
}

/**
 * Background renders a background.
 */
export const Background = ({
  className,
  children,
  color = theme.color.neutral[10],
  gradient = 'none',
  src,
}: BackgroundProps) => {
  return (
    <Wrapper
      className={className}
      $color={color}
      $src={src}
      $gradient={gradient}
    >
      {children}
    </Wrapper>
  );
};

interface WrapperProps {
  $color: Color;
  $src?: string;
  $gradient: Gradient;
}
const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  background: ${(props) => {
    switch (props.$gradient) {
      case 'top':
        return css`linear-gradient(180deg, ${props.$color} -60%, transparent 110%)`;
      case 'bottom':
        return css`linear-gradient(0deg, ${props.$color} -60%, transparent 110%)`;
      case 'left':
        return css`linear-gradient(90deg, ${props.$color} -60%, transparent 110%)`;
      case 'right':
        return css`linear-gradient(270deg, ${props.$color} -60%, transparent 110%)`;
      case 'none':
        return props.$color;
      default:
        return props.$color;
    }
  }};
  ${(props) =>
    props.$src &&
    css`
      background-image: url(${props.$src});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    `};
`;

Background.displayName = 'Background';

export default Background;
